<template>
    <div class="top">
      <div class="logo-box">
        <img class="logo" alt="浩润集团" src="../assets/logo.png">
      </div>
      <div class="nav" @click="chooseHandler">
        <span :class=" indexId === '0' ? 'nav-color' : '' " id=0>首页</span>
        <span :class=" indexId === '1' ? 'nav-color' : '' " id=1>关于浩润</span>
        <span :class=" indexId === '2' ? 'nav-color' : '' " id=2>业务布局</span>
        <span :class=" indexId === '3' ? 'nav-color' : '' " id=3>产品中心</span>
        <span :class=" indexId === '4' ? 'nav-color' : '' " id=4>新闻资讯</span>
        <span :class=" indexId === '5' ? 'nav-color' : '' " id=5>人才招聘</span>
        <span :class=" indexId === '6' ? 'nav-color' : '' " id=6>联系我们</span>
      </div>
    </div>
</template>

<script>
import { defineComponent, watch, ref, reactive } from 'vue'
import router from '@/router/index.js'
import { useRoute } from 'vue-router'

export default defineComponent({
  name: 'TopNav',
  setup () {
    const indexId = ref('0')
    const route = useRoute()
    const state = reactive({
      path: [
        '/',
        '/about',
        '/business',
        '/product',
        '/news-information',
        '/recruitment',
        '/contact',
        '/news-information/news-detail'
      ]
    })
    watch(
      () => route.path,
      (val) => {
        state.path.forEach((element, index) => {
          if (val === element) {
            if (val === '/news-information/news-detail') {
              indexId.value = '4'
            } else {
              indexId.value = index + ''
            }
          }
        })
      }
    )
    function chooseHandler (e) {
      if (indexId.value === e.target.id) {
        window.location.href = window.origin + state.path[e.target.id]
      } else {
        indexId.value = e.target.id
        switch (e.target.id) {
          case '0':
            router.push('/')
            break
          case '1':
            router.push('/about')
            break
          case '2':
            router.push('/business')
            break
          case '3':
            router.push('/product')
            break
          case '4':
            router.push('/news-information')
            break
          case '5':
            router.push('/recruitment')
            break
          case '6':
            router.push('/contact')
            break
          default:
            break
        }
      }
    }
    return {
      indexId,
      chooseHandler
    }
  }
})
</script>

<style lang="scss" scoped>
@mixin wh($width, $height) {
    width: $width;
    height: $height;
}
@mixin font($size, $weight, $color) {
    font-size: $size;
    color: $color;
    font-weight: $weight;
}
.top{
  width: 100%;
  height: 1rem;
  position: fixed;
  overflow: hidden;
  top: 0;
  background-color: #9A2E31;
  display:flex;
  align-items: center;
  justify-content: center;
  // text-align: center;
  z-index: 999;
  .logo-box{
    margin-right: 2.3rem;
    .logo {
    @include wh(1.45rem, 0.58rem);
    // margin-left: 1rem;
  }
  }
  .nav {
    & span{
      @include font(0.18rem,400,#fefefe);
      padding: 0.1rem 0.20rem;
      cursor:pointer;/*鼠标变小手*/
    }
    .nav-color{
      color:#b39b77;
      font-weight: bold;
      border-top: 0.01rem solid #b39b77;
    }
  }
}
</style>
